export const PRIZES = 'prizes'
